export { default } from "./useLazyRef.mjs";